// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1dde36e8","732":"201a6050","977":"3ffce091"}[chunkId] + ".chunk.js";
};